import { useEffect, useState } from "react"
import axiosInstance from "../axios/axiosConfig"
import { message } from "antd"

export const useCalculateProjectionMeters = (labelCount, knifeCode) => {
  const [knife, setKnife] = useState(null)
  const [totalMeters, setTotalMeters] = useState(undefined)

  useEffect(() => {
    if (labelCount === undefined || knifeCode === undefined) {
      // handle undefined inputs inside the hook
      setTotalMeters(undefined)
      message.error("no knife found!")
      return
    }

    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/searchByCode?code=${encodeURIComponent(knifeCode)}`
        )
        setKnife(response.data)
      } catch (error) {
        console.error("Failed to fetch data:", error)
      }
    }

    fetchData()
  }, [labelCount, knifeCode]) // dependencies

  useEffect(() => {
    if (knife) {
      const countInThousands = labelCount / 1000
      const a1 = (knife.height + knife.gapRaport) * 0.001
      const a2 = (1000 / knife.rowss).toFixed(2)
      const a3 = Math.ceil(a1 * a2)
      const a4 = a3 * countInThousands
      setTotalMeters(a4)
    }
  }, [knife, labelCount])

  return { totalMeters }
}
